export const DSN_SORT_COLUMNS = {
  Status: { label: 'Statut', odataField: 'Status' },
  Nature: { label: 'Nature', odataField: 'Nature' },
  CodeTypeDeclaration: { label: 'Type', odataField: 'CodeTypeDeclaration' },
  'DsnTiersDeclareObj/RaisonSociale': {
    label: 'Raison Sociale',
    odataField: 'DsnTiersDeclareObj/RaisonSociale',
  },
  Etablissement: { label: 'Etablissement', odataField: 'Etablissement' },
  SalarieArretTravail: { label: 'Salarié', odataField: 'SalarieArretTravail' },
  Periode: { label: 'Période', odataField: 'DateDebutPeriode' },
  DateCreationInterchange: { label: 'Déposé le', odataField: 'DateCreationInterchange' },
  DateSuivi: { label: 'Actualisé le', odataField: 'DateSuivi' },
} as const;

export type DsnSortColumn = keyof typeof DSN_SORT_COLUMNS;
export type DsnSortDirection = 'ascending' | 'descending';

export interface DsnSortCriterion {
  column: DsnSortColumn;
  direction: DsnSortDirection;
}

export type DsnSortState = DsnSortCriterion[];

export const DSN_SORT_STORAGE_KEY = 'dsn-list-sort';

export const DSN_SORT_COLUMN_KEYS = Object.keys(DSN_SORT_COLUMNS) as DsnSortColumn[];

export const INITIAL_DSN_SORT: DsnSortState = [
  {
    column: 'DateSuivi',
    direction: 'descending',
  },
];
